// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m2-0";
export var assigneeDetails = "_m2-1";
export var assigneeInfo = "_m2-2";
export var dropdownContainer = "_m2-4";
export var dropdownImage = "_m2-5";
export var editAssigneeInfo = "_m2-3";
export var editAssigneeModalContainer = "_m2-6";
export var hidden = "_m2-8";
export var input = "_m2-7";